import { Box, Flex, Skeleton, rem } from "@mantine/core";

type DiscoverPromoCarouselPlaceholderProps = {
  /** Matches mobile strip carousel height */
  layout: "mobile-strip" | "desktop-aside";
  /** Fixed height for compact desktop-aside (home hero). */
  height?: number;
};

/**
 * Reserves the same space as DiscoverPromoCarousel while promo slides load,
 * so Embla is not mounted with a partial list then re-inited (avoids layout jitter).
 */
export default function DiscoverPromoCarouselPlaceholder({
  layout,
  height,
}: DiscoverPromoCarouselPlaceholderProps) {
  if (layout === "mobile-strip") {
    return (
      <Flex
        w="100%"
        maw="100%"
        mih={70}
        h={70}
        align="stretch"
        wrap="nowrap"
        style={{
          borderRadius: rem(12),
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <Box flex={1} miw={0} p="xs">
          <Skeleton height={14} radius="sm" mx="auto" maw="85%" mb={6} />
          <Skeleton height={10} radius="sm" mx="auto" maw="70%" />
        </Box>
        <Skeleton w={rem(76)} style={{ flexShrink: 0, alignSelf: "stretch" }} radius={0} />
      </Flex>
    );
  }

  return (
    <Box
      h={height ?? "100%"}
      w="100%"
      style={{
        flex: height ? "0 0 auto" : 1,
        minHeight: height ?? 0,
        display: "flex",
        flexDirection: "column",
      }}
      p={height ? "xs" : "md"}
    >
      <Skeleton height={14} radius="sm" mx="auto" maw="90%" mb="sm" />
      <Skeleton height={12} radius="sm" mx="auto" maw="75%" mb="sm" />
      <Skeleton height={12} radius="sm" mx="auto" maw="60%" style={{ marginTop: "auto" }} />
    </Box>
  );
}
